import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn/ui 公式ユーティリティ。Tailwind クラスのマージを安全に行う。 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
